import React from 'react';
import { IProps as IBlockProps } from '@/blocks/MetaDataBlock/MetaDataBlock.interface';
import type { ILink } from '@/types/base';
import MetaDataBlock from '@/blocks/MetaDataBlock/MetaDataBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import * as translation from '@/utils/TranslationComponent/translation.utilities';

export interface IBlockInputProps {
  items: {
    title?: string;
    type?: 'text' | 'pill' | 'link';
    text?: string | ILink[] | null;
  }[];
  socials: Array<{
    icon: string;
    link: {
      text?: string;
      target?: HTMLAnchorElement['target'];
      href: HTMLAnchorElement['href'];
      title?: string;
      ariaLabel?: string;
    };
  }>;
  [key: string]: any;
}

const mapInputToProps = (input: IBlockInputProps): IBlockProps => {
  const { items, social, buttons, ...rest } = input;
  return {
    items: items
      .map((item) => {
        const { title, type, text } = item;

        if (!type && !text) {
          return undefined; // Skip items without type or text
        }

        return {
          title: title,
          text: text || undefined,
          type: type || 'text', // Default to 'text' if type is not provided
        };
      })
      .filter((item): item is NonNullable<typeof item> => !!item),
    socialLinks:
      social && social.length > 0
        ? social.map((social: any) => {
            return {
              icon: social?.icon || 'chevron-right',
              url: social?.link?.href || '#',
              label: social?.link?.text || 'DEFAULT TEXT',
            };
          })
        : undefined,
    buttons: buttons
      ? buttons.map((button: any) => translation.mapAnchorProps(button))
        : undefined,
    ...rest, // Pass through BlockWrapper related settings
  };
};

const BlockTranslation: React.FC<IBlockInputProps> = (inputProps) => {
  return (
    <TranslationComponent
      inputProps={inputProps}
      TargetComponent={MetaDataBlock}
      mapProps={mapInputToProps}
    />
  );
};

export default BlockTranslation;
